document.addEventListener("DOMContentLoaded", () => {
    addProdWishlist()
    if ($('.boutiques__title').length > 0){
        storeFinder();
    }
    mobileBubbleCount();
    hideShowMore()
})

/* PRODUCT CARD */
/* ADD TO WISHLIST /ADDED IN WISHLIST PDP*/
function addProdWishlist() {
    if ($('section.product-card').length > 0){
        checkList();
    }
}

if ($('section.product-card').length > 0) {
    if(document.getElementById('wishlistContainer')){
        document.getElementById('wishlistContainer').addEventListener('click', function () {
            document.getElementsByClassName('iWishAdd')[0].click()
            checkList();
        })
    }
    if(document.getElementById('addToWishlistPop')){
        document.getElementById('addToWishlistPop').addEventListener('click', function () {
            document.getElementsByClassName('iWishAdd')[0].click()
            checkList();
        })
    }
}

/* check if the product is in wishlist (local storage). If so change the add to wishlist button*/
function checkList(){
    let variant = document.querySelector('product-form.product-form input[name="id"]').value;
    let list = window.localStorage.getItem('iWishlistmain');
    if (list) {
        if(list.includes(variant)){
            document.getElementById('addToWishlist').textContent= 'ADDED IN WISHLIST';
            document.getElementById('addToWishlistPop').textContent= 'ADDED IN WISHLIST';
        }
        else {
            document.getElementById('addToWishlist').textContent= 'ADD TO WISHLIST';
            document.getElementById('addToWishlistPop').textContent= 'ADD TO WISHLIST';
        }
    }
}
/* OUT OF STOCK BUTTON PDP*/
function outOfStock( text = "OUT OF STOCK") {
    //text = "OUT OF STOCK.";
    setTimeout(() => {
        document.querySelector('.add-to-cart__box.add-to-cart__box--default').firstElementChild.innerHTML = text //"OUT OF STOCK"
        document.querySelector('.add-to-cart__box.add-to-cart__box--default').classList.add('out-of-stock')
        document.querySelector('.add-to-cart').addEventListener('click', function(){
            this.classList.add('not-active');
        });

        document.querySelector('.product-popup .add-to-cart__box.add-to-cart__box--default').firstElementChild.innerHTML = text //OUT OF STOCK"
        document.querySelector('.product-popup .add-to-cart__box.add-to-cart__box--default').classList.add('out-of-stock')
        document.querySelector('.product-popup .add-to-cart').addEventListener('click', function(){
            this.classList.add('not-active');
        });
    }, 50);
}
    function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
};
}
/* CUSTOM SELECT SORT BY*/
$(document).ready(function () {
    $('.catalog-sort__select.select.choices__input').on('change', function() {
        const e = document.querySelector("#SortBy");
        e.value = $('.catalog-sort__select.select.choices__input option').val();
        e.dispatchEvent(new Event("input", {
            bubbles: !0
        }))
    })
})
/* END CUSTOM SELECT SORT BY*/

/* Store finder */
if($('span.search_filter').length > 0) {
    $('span.search_filter')[0].addEventListener('click', storeFinder)
}

function storeFinder () {
    setTimeout(function(){
        if ($('.boutiques-card')){
        let title = $('.boutiques-card .boutiques-card__title');
        for (const titleKey of title) {
            if(titleKey.querySelector('span').innerText.toLowerCase().includes('clive')){
                $(titleKey).addClass('boutiques-card__title--brand');
            }
        }
    }
    },1000)
}
/* end Store finder */

/* Catalog */
function showProducts() {
    $('.catalog__item.catalog-hidden').show();
    $('#catalog-more').hide()
}
function hideShowMore() {
    if ($('.catalog__item.catalog-hidden').length <=0){
        $('#catalog-more').hide()
    }
}
$('.no-js-hidden.form__button.button').on('click', function (){
    hideShowMore()
})
/* end Catalog */


/* Cart count mobile*/

$(window).resize(function() {
    mobileBubbleCount();
});

function mobileBubbleCount() {
    let countBubble = $('a#cart-icon-bubble.header__icon.header__icon--cart.link.focus-inset');
    innestCountBubble = countBubble
    if ($(window).width() < 1023) {
        let mobileCountContainer = $('li.header-controls__item.mobile');
        mobileCountContainer.html(innestCountBubble);
    }
    else {
        $('.header-controls__item.header__icons.desktop').html(innestCountBubble);
    }
}

/* end Cart count mobile*/
/*  REVIEWS */
function reviewSystem(){
    if($('.spr-starratings.spr-review-header-starratings').length > 0){
        $('.spr-reviews').flickityResponsive({
            pageDots: false,
            // create and enable page dots
            prevNextButtons: false,
            // creates and enables buttons to click to previous & next cells
            cellAlign: 'left',
            contain:'true',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        wrapAround: true,
                        cellAlign: "center",
                        freeScroll: false,
                        prevNextButtons: false,
                        pageDots: true,
                        contain:'true',
                        adaptiveHeight: true
                    }
                }
            ]
        });
        let reviews = $('.spr-starratings.spr-review-header-starratings');
        for (const review of reviews) {
            let sv = document.createElementNS('http://www.w3.org/2000/svg',"svg");
            let path = document.createElementNS('http://www.w3.org/2000/svg',"path");
            sv.setAttributeNS(null, "viewBox", "0 0 523.1 18");
            path.setAttributeNS(null, "d", "M0.1,17.5C0.3,18,0.3,18,0.3,18c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.9-0.2c0.8-0.2,1.9-0.5,3.3-0.9c2.9-0.8,7.1-1.9,12.4-3.1c10.5-2.5,25.3-5.6,42-8.1c33.4-5,74.8-7.7,106.5,1.8l0.3-0.9C134-3.2,92.5-0.5,59,4.6C42.3,7.1,27.5,10.2,17,12.7C11.7,14,7.4,15,4.5,15.8c-1.5,0.4-2.6,0.7-3.4,0.9c-0.4,0.1-0.7,0.2-0.9,0.2c-0.1,0-0.2,0-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0C0,17.1,0,17.1,0.1,17.5z M165.7,7.3c16,4.8,46.4,7.6,82.9,9.1c36.5,1.4,79.2,1.4,119.9,0.5c40.7-1,79.4-2.9,107.8-5.3c14.2-1.2,25.9-2.5,34-4c4-0.7,7.2-1.4,9.4-2.2c1.1-0.4,1.9-0.8,2.5-1.2c0.6-0.4,1-0.9,1-1.6l-1,0.1c0,0.1,0,0.3-0.5,0.7c-0.5,0.3-1.2,0.7-2.3,1c-2.1,0.7-5.2,1.4-9.2,2.1c-8,1.4-19.7,2.7-33.9,3.9c-28.4,2.4-67.1,4.3-107.7,5.3c-40.7,1-83.4,0.9-119.9-0.5c-36.5-1.4-66.8-4.3-82.6-9L165.7,7.3z");
            sv.classList.add('svg-icon');
            sv.appendChild(path)
            sv.classList.add('product-customers-review-card__line')
            let star = review.ariaLabel;
            let content = star.replace(' of ', '/').replace(' stars','')
            let result = document.createElement('span');

            result.innerHTML = '' + content
            $(review.parentNode).prepend(result)
            $(result).append(sv)
            $(review).hide();

        }
    }else {
        setTimeout(function () {
            if ($('.spr-summary-caption').text().includes('Based')){
                reviewSystem();
            }
        },2000)
    }
}
/*  ENDREVIEWS */